// extracted by mini-css-extract-plugin
export default {"plan_details":"PlanDetails_plan_details__rApjU","list_item":"PlanDetails_list_item__3K+YR","item_name":"PlanDetails_item_name__ivjaN","item_value":"PlanDetails_item_value__dwLpB"};